import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './faq-entries.magic.css.js';
import script from './faq-entries.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"part":"wrapper","data-v-test-id":"faq-entries"}},[(_vm.isLoading)?_c('magic-ui-loader',{staticClass:"loader",attrs:{"part":"loader"}}):[_c('magic-ui-link',{attrs:{"to":_vm.RoutablePage.FAQ}},[(_vm.category)?_c('magic-ui-icon',{staticClass:"icon",attrs:{"name":"left-arrow-long","part":"icon","data-v-test-id":"faq-entries-back-button"}}):_vm._e()],1),_vm._v(" "),_vm._l((_vm.categoryEntries),function(entry,index){return _c('magic-faq-entry',{key:entry.id,staticClass:"faq-entry",attrs:{"part":"faq-entry","data-v-test-id":"faq-entries-entry","question":entry.question,"answer":entry.answer,"initially-visible":_vm.openedEntries.includes(index)},on:{"toggle":function($event){return _vm.onToggle(index, $event.detail[0])}}})})]],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-7adcecc0_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-7adcecc0";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
